import React, { Component } from 'react';
import { MyContext, MyHeading, MyGlobal } from '../components/GlobalContext';

export class MenuComponent extends Component {
    static displayName = MenuComponent.name;

    constructor(props) {
        super(props);
        this.state = { data: props.menuData, loading: true, labelText: "Select an option" };
        this.history = props.history;
    }

    componentDidMount() {
        this.setState({loading: false });
    }
    goto(page) {
        this.history.push(page);
    }
    rowClicked(menuPath) {
        if (menuPath === "LogOff") {
            MyGlobal.logout();
            this.history.push('/#');
        }
        else {
            this.history.push(menuPath);
        }
    }

    renderTable(data) {
        return (
            <MyContext.Consumer>
                {context => (
                    <table className='table table-striped' aria-labelledby="tabelLabel">
                        <tbody>
                            {data.map(row =>
                                <tr key={row.path}
                                    onClick={() => {

                                        this.rowClicked(row.path);
                                    }}>
                                    <td>{row.menuName}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                )}
            </MyContext.Consumer>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderTable(this.state.data);

        return (
            <div>
                <MyHeading>{this.state.labelText}</MyHeading>
                {contents}
            </div>

        );
    }

}
